import Header from '../../components/common/Header';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { validateLogin } from '../../services/validate-login';
import LoanContent from '../../components/myLoan/LoanContent';

export default function MyLoans() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, []);
  return (
    <>
      <div className="min-h-full">
        <Header title="Dashboard"/>
        <header className="bg-white shadow">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">My Loans</h1>
          </div>
        </header>
        <main>
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <LoanContent />
          </div>
        </main>
      </div>
    </>
  )
}
